import * as React from "react";
import {Box, Button, Stack, Typography, Container} from "@mui/material";
import AdviceDynamic from "./AdviceDynamic";
import AdviceRelateCard from "./AdviceRelateCard";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const AdviceDynamicPart = ({children,categories}) => {
    const {mode} = useDarkMode();
    return (
        <Box  style={{backgroundColor: mode.settings.backgroundColor}}>
            <Container maxWidth={"lg"} spacing={2}>
                {
                    children && children.map((child) =>
                        <AdviceDynamic child={child[0]}></AdviceDynamic>
                    )
                }
                <br/><br/>
                 <Stack
                    direction="row"
                    justifyContent="space-around"
                    spacing={2}
                >
                    {
                        categories && categories.map((category) =>
                            <AdviceRelateCard name={category.name} categoryId={category.id}></AdviceRelateCard>
                        )
                    }

                </Stack>
            </Container>
            <br/>
        </Box>
    )
}

export default AdviceDynamicPart;
